export default {
    TAIL_NUMBER: 'tailnumber',
    CLIENT_TRANSACTION_ID: 'clientTransactionId',
    CLIENT_CODE: 'clientCode',
    REQUEST_DATE: 'requestDate',
    CLINT_CODE_NAME: 'ONBOARDPORTAL',
    JWT: 'jwt',
    FLIGHT_ID: 'flightId',
    LANGUAGE_CODE: 'languageCode',
    TAIL: "tail",
    RECOIL_PERSIST: "recoil-persist",
    PANASONIC_LOG: "panasonic_log",
    WARNING_DIALOG_CHECK_DATA: "warningDialogPleaseCheckYourDataUsage",
    MOBIL_APP: "mobilApp",
    FEEDBACK_COUNT: "feedbackCount",
    FEEDBACK_SHOW_COUNT: 3,
    FREE_INTERNET_RIGHTS: "FreeInternetRights",
    INTERNET_PACKAGES: "InternetPackages",
    TURKISH_AIRLINES_URL: "https://www.turkishairlines.com",
    MOBIL_API_KEY: "INT1155ecd3-195c-4eab-8b3f-14146e37b94d.38b4d979-70b7-4a37-8c2f-e8483f430f28",
    AUTHORIZATION: "Authorization",
}
